export function BookingDiaryService (
  $q,
  $state,
  $stateParams,
  $translate,
  dateParsing,
  jsonApi,
  uiCalendarConfig,
  workshopAPI
) {
  //  constructor                used to initialize class.
  //  params: settings           {Object} company settings.
  //          mechanicGroups     [Array] array of mechanic groups
  //                             containing names and ids.
  const BookingDiary = function (settings, mechanicGroups) {
    var self = this;

    this.calendarConfig      = uiCalendarConfig;
    this.colors              = [];
    this.dayOfMonth          = 0;
    this.dayViewName         = 'multiColAgendaDay';
    this.events              = [];
    this.jobs                = [];
    this.jobStatusTypes      = settings.jobStatusTypes;
    this.mechanicGroupIndex  = $stateParams.group_index || 0;
    this.mechanicGroups      = [];
    this.shopCloses          = settings.shop_closes || '18:00:00';
    this.shopOpens           = settings.shop_opens || '08:00:00';
    this.showAllShopForMonth = settings.show_all_shop_for_month;
    this.tab                 = jsonApi.parse(localStorage.getItem('bookingDiaryTab')) || 'allocated';
    this.view                = {};
    this.weekViewName        = 'agendaWeek';

    // if the shop doesn't close until after midnight, force the
    // calendar to stop at 11:59:59 PM.
    if (moment(this.shopCloses, 'hh:mm:ssZ').isBefore(moment(this.shopOpens, 'hh:mm:ssZ'))) {
      this.shopCloses = '23:59:59' + moment(this.shopCloses, 'hh:mm:ssZ').format('Z');
    }

    this.tabs = [
      {
        active : self.tab === 'allocated',
        heading: $translate.instant('JS_SPACE.TABS.CALENDAR'),
        id     : 'allocated',
        onClick () {
          localStorage.setItem('bookingDiaryTab', angular.toJson('allocated'));

          $state.reload();
        }
      },
      {
        active : self.tab === 'simplified',
        heading: $translate.instant('JS_SPACE.TABS.LIST'),
        id     : 'simplified',
        onClick () {
          localStorage.setItem('bookingDiaryTab', angular.toJson('simplified'));

          $state.reload();
        }
      }
    ];

    // remove unnecessary key/value pair in returned group data
    for ( let i = 0; i < mechanicGroups.length; i++ ) {
      mechanicGroups[i] = mechanicGroups[i][i];
    }

    // configure this.mechanicGroups
    angular.forEach(mechanicGroups, mechanicGroup => {
      var group = {
        headerColumns: [],
        ids          : [],
        names        : []
      };

      group.group_name = mechanicGroup.group_name;

      angular.forEach(mechanicGroup.mechanic_ids, mechanic => {

        angular.forEach(mechanic, ( name, id ) => {
          group.ids.push(id);
          group.names.push(name);
          group.headerColumns.push(
            `<a class="pointer" ui-sref="app.booking-diary({
              date              : ${$stateParams.date},
              group_index       : 0,
              mechanic          : ${encodeURI(name)},
              mechanicId        : ${id},
              view              : day,
              viewSingleMechanic: true
            })">
              ${name}
            </a>`
          );
        });
      });

      self.mechanicGroups.push(group);
    });

    // if url contains mechanic, user clicked a mechanic
    // from month view or day view. If they clicked from
    // month view, we change to day view and find the group
    // containing the mechanic. If they clicked from day view,
    // we build a new group containing only that mechanic.
    if ($stateParams.mechanic) {
      if ($stateParams.viewSingleMechanic) {
        this.mechanicGroupIndex = 0;

        this.mechanicGroups.unshift({
          group_name: $stateParams.mechanic,
          ids       : [ $stateParams.mechanicId ],
          names     : [ $stateParams.mechanic ]
        });
      }
      else {
        for ( let i = 0; i < this.mechanicGroups.length; i++ ) {
          for ( let j = 0; j < this.mechanicGroups[i].ids.length; j++ ) {
            if (this.mechanicGroups[i].ids[j] === $stateParams.mechanicId) {
              this.mechanicGroupIndex = i;
            }
          }
        }
      }
    }

    this.mechanicGroup = this.mechanicGroups.length
      ? this.mechanicGroups[this.mechanicGroupIndex]
      : {
        group_name   : 'N/A',
        headerColumns: [],
        ids          : [],
        names        : []
      };
  };

  //  bookEvent     used to book an unassigned job dropped
  //                onto the calendar.
  //  params: event {Object} the event object.
  BookingDiary.prototype.bookEvent = function (event) {
    const self = this;

    return workshopAPI.patch('/event_time', {
      estimated_hours : event.estimated_hours,
      event_id        : event.event_id,
      event_item_id   : event.event_item_id,
      id              : event.id,
      local_start_time: moment(event.start).format('YYYY-MM-DDTHH:mm:ss') + moment().format('Z'),
      mechanic_id     : self.mechanicGroup.ids[event.column]
    }, 'event_time');
  };

  //  buildAssignedMechanicsList  used to build array of unique mechanic
  //                   names that are assigned to an event.
  //  params: events   [Array] array of events.
  BookingDiary.prototype.buildAssignedMechanicsList = function (events) {
    var self = this;

    self.assignedMechanics = [];

    // build array of assigned mechanics.
    angular.forEach(events, event => {
      if (self.assignedMechanics.indexOf(event.mechanic_id) < 0) {
        self.assignedMechanics.push(event.mechanic_id);
      }
    });
  };

  //  buildEvents     used to assign the built classes
  //                  to mechanic events as well as build
  //                  drop container events for day view.
  //  params: events  [Array] array of events.
  BookingDiary.prototype.buildEvents = function (events) {
    var self = this;

    for ( let i = 0; i < events.length; i++ ) {
      events[i].column = self.mechanicGroup.names.indexOf(events[i].display_name);
    }

    if (self.isDayView()) {

      // Build a background event for each column that will
      // be used for catching dropped unassigned jobs.
      for ( let i = 0; i < self.mechanicGroup.names.length; i++ ) {
        events.push({
          column    : i,
          end       : moment(self.params.date).format('MMM D YYYY 23:59:59Z'),
          identifier: 'column-' + i,
          rendering : 'background',
          start     : moment(self.params.date).format('MMM D YYYY 00:00:01Z')
        });
      }

    }

    return events;
  };

  //  buildParams   used to build appropriate params for
  //                calls to retrieve events.
  BookingDiary.prototype.buildParams = function () {
    var self = this;

    if (self.isMonthView()) {
      self.params = {
        mechanic_ids: self.mechanicGroup.ids,
        month       : moment(dateParsing.getFirstOfMonth(self.start.add(7, 'days'))).format('M'),
        year        : moment(dateParsing.getFirstOfMonth(self.start)).format('YYYY')
      };
    }
    else {
      self.params = {
        date        : self.start.format('YYYY-MM-DD'),
        mechanic_ids: self.mechanicGroup.ids
      };
    }

    return $q.when(self.params);
  };

  //  buildRouteAndReload used to build url with appropriate
  //                      params and reload the route.
  //  params: options     {Object} options object.
  BookingDiary.prototype.buildRouteAndReload = function (options) {
    var self = this;

    $state.go('app.booking-diary', {
        view              : self.view.intervalUnit,
        group_index       : self.mechanicGroupIndex,
        date              : options.includeDate ? (options.date ? options.date : self.start.format('YYYY-MM-DD')) : undefined,
        mechanic          : options.mechanic,
        viewSingleMechanic: options.viewSingleMechanic
    }, { reload: true });
  };

  //  configureEvents   used to call for events. Then configures
  //                    event data for the current fullCalendar
  //                    view.
  //  params: start     Moment of calendar start date.
  //          end       Moment of calendar end date.
  //          timezone  Passed from fullCalendar.
  //          callback  Function passed from fullCalendar.
  BookingDiary.prototype.configureEvents = function (start, end, timezone, callback) {
    var self = this;

    self.end   = end;
    self.start = start;

    // getEvents() is being called multiple times on page
    // load with null parameters. Only initiate event
    // retrieval when params are defined.
    if (start) {
      self.buildParams();
      self.getEvents()
      .then(events => {

        // if month is current view, no need to define
        // classes for mechanic events.
        if (self.isMonthView()) {
          self.events = events;

          callback(self.events);
        }
        else {
          self.getUnavailableTimes()
          .then(data => {
            events = data
              ? events.concat(data)
              : events;

            return self.getUnscheduledTimes();
          })
          .then(data => {
            events = data
              ? events.concat(data)
              : events;
          })
          .finally(() => {
            self.buildAssignedMechanicsList(events);
            self.events = self.buildEvents(events);

            callback(self.events);
          });
        }
      });
    }
  };

  BookingDiary.prototype.configureEventLayout = function ( event, element, view ) {
    const self  = this;

    if (self.isWeekView()) {
      const width = `${ ( 100 / self.assignedMechanics.length ) / 2 }%`;

      element.width(width);

      const eventOffset   = 100 / self.assignedMechanics.length;
      const index         = self.assignedMechanics.indexOf(event.mechanic_id);
      const initialOffset = 100 / self.assignedMechanics.length * 0.225;

      element.css({
        left: `${ index * eventOffset + initialOffset }%`
      });
    }
  };

  BookingDiary.prototype.getDefaultView = function ( view ) {
    const self = this;

    if ( view === 'day' ) {
      return self.dayViewName;
    }

    if ( view === 'week' ) {
      return self.weekViewName;
    }

    return view;
  };

  BookingDiary.prototype.getEventApiEndpoint = function () {
    const self = this;

    if (self.isDayView()) {
      return '/event_times/bookings_for_day';
    }
    if (self.isWeekView()) {
      return '/event_times/bookings_for_week';
    }
    if (self.isMonthView()) {
      return '/event_times/bookings_for_month';
    }
  };

  //  getEvents  used to retrieve events for current calendar
  //             view.
  BookingDiary.prototype.getEvents = function () {
    var self = this;

    if (!self.view.intervalUnit) {
      return $q.reject();
    }

    self.dayOfMonth = 0;

    return workshopAPI.post(self.getEventApiEndpoint(), self.params)
    .then(events => {
      if (self.isDayView() || self.isWeekView()) {
        var configuredEvents = [];

        // loop through events object to get date
        angular.forEach(events, event => {

          // loop through each mechanic for the day
          angular.forEach(event, mechanic => {
            // if mechanic is an array, it's empty.
            if (!angular.isArray(mechanic)) {

              // loop through each event time for the mechanic
              // and configure the event.
              angular.forEach(mechanic.event_times, eventTime => {
                eventTime.allDay = false;
                eventTime.color  = mechanic.color || '#41BDE1';
                eventTime.end    = moment(eventTime.local_end_time).format('YYYY-MM-DDTHH:mm:ss');
                eventTime.start  = moment(eventTime.local_start_time).format('YYYY-MM-DDTHH:mm:ss');
                eventTime.title  = mechanic.display_name;

                configuredEvents.push(eventTime);
              });
            }
          });
        });

        return configuredEvents;
      }
      if (self.isMonthView()) {
        var configuredEvent    = {};
        var configuredEvents   = [];
        var eventConsolidation = [];

        // loop through each date of the month
        angular.forEach(events, ( event, date ) => {
          configuredEvent    = {};
          eventConsolidation = [];

          // if !showAllShopForMonth, configure individual events.
          if (!self.showAllShopForMonth) {

            // loop through each mechanic for the day.
            angular.forEach(event, ( mechanic, mechanicId ) => {
              // check for object. If false, the current iteration is
              // an integer for total hours/jobs.
              if (angular.isObject(mechanic)) {
                mechanic.allDay = false;
                mechanic.date   = date;
                mechanic.id     = mechanicId;
                mechanic.title  = mechanic.display_name;

                eventConsolidation.push(mechanic);
              }
            });
          }

          configuredEvent.allDay                  = false;
          configuredEvent.available_loan_vehicles = event.available_loan_vehicles;
          configuredEvent.date                    = date;
          configuredEvent.monthViewConsolidation  = eventConsolidation;
          configuredEvent.start                   = moment(date, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss');
          configuredEvent.title                   = 'required';
          configuredEvent.total_available_hours   = event.total_available_hours;
          configuredEvent.total_booked_hours      = event.total_booked_hours;
          configuredEvent.total_event_count       = event.total_event_count;
          configuredEvent.total_number_of_jobs    = event.total_number_of_jobs;

          if (self.showAllShopForMonth) {
            configuredEvent = angular.extend(configuredEvent, event);
          }

          configuredEvents.push(configuredEvent);
        });

        return configuredEvents;
      }

      return $q.when(events);
    });
  };

  //  getEventTemplate  used to retrieve the appropriate event
  //                    template depending on the current view.
  //  params: event     {Object} current event object.
  BookingDiary.prototype.getEventTemplate = function (event) {
    var self = this;

    if (self.isDayView()) {
      return event.mechanic_id
      ? '<wor-event job-statuses="jobStatuses" event="event"></wor-event>'
      : '';
    }

    if (self.isWeekView()) {
      return '<wor-week event="event"></wor-week>';
    }

    if (self.isMonthView()) {
      self.dayOfMonth++;

      // template for large whole-shop dots.
      if (self.showAllShopForMonth) {
        return '<wor-shop event="event"></wor-shop>';
      }

      // template for individual mechanic/event dots.
      else {
        return '<wor-day event="event"></wor-day>';
      }
    }
  };

  //  getNextGroup  used to get the next group of
  //                mechanic's data.
  BookingDiary.prototype.getNextGroup = function () {
    var self = this;

    if (parseInt(self.mechanicGroupIndex) !== (self.mechanicGroups.length-1)) {
      self.mechanicGroupIndex++;
      self.mechanicGroup = self.mechanicGroups[self.mechanicGroupIndex];

      self.buildRouteAndReload({ includeDate: true });
    }
  };

  //  getPreviousGroup  used to get the previous group
  //                    of mechanic's data.
  BookingDiary.prototype.getPreviousGroup = function () {
    var self = this;

    if (parseInt(self.mechanicGroupIndex) !== 0) {
      self.mechanicGroupIndex--;
      self.mechanicGroup = self.mechanicGroups[self.mechanicGroupIndex];

      self.buildRouteAndReload({ includeDate: true });
    }
  };

  //  getUnassignedJobs  used to retrieve unassigned jobs.
  //  params: date       Moment for date of jobs.
  BookingDiary.prototype.getUnassignedJobs = function (date) {
    var self = this;

    return workshopAPI.get('/events/unassigned', moment(date).format('YYYY-MM-DD'))
    .then(jobs => {
      // Since these events are not associated with
      // any mechanic, we need to give a temporary
      // title for fullCalendar to recognize as
      // droppable elements.
      jobs.map(job => {
        job.title = $translate.instant('JS_SPACE.BOOKINGS.UNASSIGNED');

        return job;
      });

      self.jobs = jobs;

      return $q.when(jobs);
    });
  };

  //  getUnavailableTimes  used to retrieve unavailable times
  //                       for current calendar view.
  BookingDiary.prototype.getUnavailableTimes = function () {
    var self = this;

    const url = self.isWeekView()
      ? '/unavailable_times/unavailable_for_week'
      : '/unavailable_times/unavailable_for_day';

    if (!self.view.intervalUnit) {
      return $q.reject();
    }

    return self.isMonthView()
      ? $q.when()
      : workshopAPI.post(url, self.params)
      .then(events => {
        var configuredEvents = [];

        // loop through each day of the week.
        angular.forEach(events, ( event, date ) => {
          // loop through each mechanic for the day.
          angular.forEach(event, unavailableTimes => {
            // loop through each unavailable time for the
            // mechanic and configure the event.
            angular.forEach(unavailableTimes, unavailableTime => {
              unavailableTime.allDay        = false;
              unavailableTime.color         = '#F9AA0B';
              unavailableTime.end           = moment(date).hour(moment(unavailableTime.local_end_time).format('HH')).minute(moment(unavailableTime.local_end_time).format('mm')).format('YYYY-MM-DDTHH:mm:ss');
              unavailableTime.isUnavailable = true;
              unavailableTime.start         = moment(date).hour(moment(unavailableTime.local_start_time).format('HH')).minute(moment(unavailableTime.local_start_time).format('mm')).format('YYYY-MM-DDTHH:mm:ss');
              unavailableTime.title         = unavailableTime.display_name;

              configuredEvents.push(unavailableTime);
            });
          });
        });

        return configuredEvents;
      });
  };

  //  getUnscheduledTimes used to retrieve unscheduled times
  //                       for mechanics in current day view.
  BookingDiary.prototype.getUnscheduledTimes = function () {
    var self = this;

    const url = '/unscheduled_hours/unscheduled_for_day';

    if ( !self.view.intervalUnit ) {
      return $q.reject();
    }

    return self.isMonthView() || self.isWeekView()
      ? $q.when()
      : workshopAPI.post(url, self.params)
        .then(events => {
          var configuredEvents = [];

          // loop through each day of the week.
          angular.forEach(events, event => {
            // loop through each mechanic for the day.
            angular.forEach(event, ( unscheduledTimes, mechanicId ) => {
              // loop through each unscheduled time for the
              // mechanic and configure the event.
              angular.forEach(unscheduledTimes, unscheduledTime => {
                unscheduledTime.allDay        = false;
                unscheduledTime.color         = '#C2C5C4';
                // added 'parseZone' to avoid unwanted timezone disruption by the system time in the calendar for the saved timezone
                unscheduledTime.end           = moment.parseZone(unscheduledTime.local_end_time).format('YYYY-MM-DD HH:mm');
                unscheduledTime.isUnscheduled = true;
                unscheduledTime.mechanic_id   = mechanicId;
                // added 'parseZone' to avoid unwanted timezone disruption by the system time in the calendar for the saved timezone
                unscheduledTime.start         = moment.parseZone(unscheduledTime.local_start_time).format('YYYY-MM-DD HH:mm');
                unscheduledTime.title         = unscheduledTime.display_name;

                configuredEvents.push(unscheduledTime);
              });
            });
          });

          return configuredEvents;
        });
  };

  //  goToUnassignedEventTime  used to view an unassigned event
  //                           time in the event times modal.
  //  params: eventTime        {Object} the event time object.
  BookingDiary.prototype.goToUnassignedEventTime = function (eventTime) {
    var self = this;

    workshopAPI.get('/event', eventTime.event_id).then( function (eventParent) {
      $state.go('app.event', {
        customer_id             : eventTime.customer_id,
        vehicle_id              : eventParent.vehicle_id,
        id                      : eventTime.event_id,
        event_item_id           : eventTime.event_item_id,
        unassigned_event_time_id: eventTime.id
      });
    });


  };

  BookingDiary.prototype.isDayView = function ( view = this.view ) {
    return view.intervalUnit === 'day';
  };

  BookingDiary.prototype.isDaySimplified = function ( view = this.view ) {
    return this.isDayView(view)
      && this.tab === 'simplified';
  };

  BookingDiary.prototype.isMonthView = function ( view = this.view ) {
    return view.intervalUnit === 'month';
  };

  BookingDiary.prototype.isWeekView = function ( view = this.view ) {
    return view.intervalUnit === 'week';
  };

  BookingDiary.prototype.showUnassignedJobs = function ( view = this.view ) {
    return this.isDayView(view)
      && !this.isDaySimplified(view)
      && this.jobs.length;
  };

  //  updateBookedEvent  used to update a booked event when
  //                     the user drags it up/down left/right
  //                     on the calendar to adjust the time
  //                     or assigned mechanic.
  //  params: event      {Object} the event object.
  BookingDiary.prototype.updateBookedEvent = function (event) {
    var self = this;

    var booking = {};

    // set url param to current date for better UX
    // when the route reloads.
    // TODO: confirm this updates the date stateParam without reloading
    // and persists any other query parameter values.
    $state.go('app.booking-diary', {
      date: self.start.format('YYYY-MM-DD')
    }, { reload: false });

    // user dragged an event in the week
    // view.
    if (self.isWeekView()) {
      booking = {
        date            : event.start.format('YYYY-MM-DD'),
        id              : event.id,
        is_default      : false,
        local_end_time  : moment(event.end).format('YYYY-MM-DDTHH:mm:ss') + moment().format('Z'),
        local_start_time: moment(event.start).format('YYYY-MM-DDTHH:mm:ss') + moment().format('Z'),
        mechanic_id     : event.mechanic_id
      };
    }

    // user dragged an event in the day
    // view.
    else {

      // make sure the start and end properties use
      // the diaries start and end to avoid wrong
      // dates caused by the fullcalendar-columns
      // plugin.
      booking = {
        date            : self.start.format('YYYY-MM-DD'),
        id              : event.id,
        is_default      : false,
        local_end_time  : self.start.format('YYYY-MM-DD') + 'T' + moment(event.end).format('HH:mm:ss') + moment().format('Z'),
        local_start_time: self.start.format('YYYY-MM-DD') + 'T' + moment(event.start).format('HH:mm:ss') + moment().format('Z'),
        mechanic_id     : self.mechanicGroup.ids[event.column]
      };
    }

    return $q.when().then(function () {
      return event.isUnavailable ? workshopAPI.patch('/unavailable_time', { unavailable_times: [ booking ] }) : workshopAPI.patch('/event_time', booking, 'event_time');
    }).then(function (data) {
      return $q.when(data);
    }, function (err) {
      return $q.reject(err);
    });
  };

  //  viewDay      used to view an event in the day view
  //                 that the user selected from the month
  //                 view.
  //  params: event  {Object} the event object.
  BookingDiary.prototype.viewDay = function (event, date, withMechanic = false) {
    var self = this;

    if (!self.isDayView()) {
      self.calendarConfig.calendars.bookingDiaryCalendar.fullCalendar('changeView', this.dayViewName);

      self.buildRouteAndReload({
        date       : date ? date.format('YYYY-MM-DD') : event.date,
        includeDate: true,
        mechanic   : ( withMechanic && event.id ) ? event.display_name : null,
        mechanicId : ( withMechanic && event.id ) ? event.id           : null
      });
    }
  };

  //  viewRender  used to check if view has been changed
  //              and if so, determine appropriate mechanic
  //              group size and date.
  BookingDiary.prototype.viewRender = function (view) {
    var self = this;

    var date = view.start.format('YYYY-MM-DD');
    var includeDate = false;

    self.view = view;

    // user selected different view.
    if (self.view.intervalUnit !== $stateParams.view) {

      // if switching to day view, group size is
      // reduced from 10 to 5.
      if (self.isDayView()) {
        date = self.view.start.format('YYYY-MM-DD');
        includeDate = true;

        self.mechanicGroupIndex *= 2;
      }

      // if switching from day view, group size is
      // doubled from 5 to 10.
      if ($stateParams.view === 'day') {
        self.mechanicGroupIndex = Math.floor(self.mechanicGroupIndex/2);
      }

      // if switching from day view to week view,
      // show week containing previously viewed day.
      if ($stateParams.view === 'day' && self.isWeekView()) {
        includeDate = true;
        date = moment(dateParsing.sunday(self.view.start.format('YYYY-MM-DD'))).add(1, 'days').format('YYYY-MM-DD');
      }

      self.buildRouteAndReload({ includeDate: includeDate, date: date });
    }

    // user clicked prev or next button.
    else if (self.isDayView() && self.start && self.start !== date) {
      self.buildRouteAndReload({
        date              : date,
        includeDate       : true,
        mechanic          : $stateParams.mechanic,
        mechanicId        : $stateParams.mechanicId,
        viewSingleMechanic: $stateParams.viewSingleMechanic
      });
    }
  };

  return BookingDiary;
}
